// index.js
import { default as trialReducer } from './reducers';
export { default as trialOperations } from './operations';
export { default as trialTypes } from './types';
export default trialReducer;